const CSV_HEADERS = [
    'Ordre #',
    'Kunde',
    'Kunde email',
    'Bestillingsdato',
    'Mødedato',
    'Rådgiver',
    'Deling',
    'Mødeklar',
    'Produkter',
    'Pris',
    'Status',
];

const EMPTY_CSV_ROW = {
    orderNumber: '',
    customerName: '',
    customerEmail: '',
    createdAt: '',
    meetingAt: '',
    advisorName: '',
    hasSharing: '',
    isMeetingReady: '',
    products: '',
    price: '',
    status: '',
};

const escapeCsvValue = (value) => {
    const stringValue = value === null || value === undefined ? '' : String(value);
    const escaped = stringValue.replace(/"/g, '""');
    const needsQuoting = /[",\n\r]/.test(escaped);
    return needsQuoting ? `"${escaped}"` : escaped;
};

const mapCsvRowToArray = (row = EMPTY_CSV_ROW) => ([
    row.orderNumber,
    row.customerName,
    row.customerEmail,
    row.createdAt,
    row.meetingAt,
    row.advisorName,
    row.hasSharing,
    row.isMeetingReady,
    row.products,
    row.price,
    row.status,
]);

export const createOrdersCsv = (rows = []) => {
    const contentRows = rows.map((row) => mapCsvRowToArray(row).map(escapeCsvValue).join(','));
    return [CSV_HEADERS.join(','), ...contentRows].join('\n');
};

export const collectAllOrdersForExport = async ({
    organisationId,
    baseParams,
    requestFilters = [],
    getAllOrders,
    pageSize = 500,
}) => {
    const collectPage = async (page, allOrders, totalCount) => {
        const currentOrders = allOrders || [];
        const requestParams = new URLSearchParams(baseParams);
        requestParams.set('page', String(page));
        requestParams.set('pageSize', String(pageSize));

        if (requestFilters.length > 0) {
            requestParams.set('filter', JSON.stringify(requestFilters));
        } else {
            requestParams.delete('filter');
        }

        const result = await getAllOrders(organisationId, requestParams);
        const orders = result?.orders ?? [];
        const nextTotalCount = typeof result?.count === 'number' ? result.count : totalCount;
        const nextOrders = [...currentOrders, ...orders];

        if (orders.length === 0 || orders.length < pageSize) {
            return nextOrders;
        }

        if (typeof nextTotalCount === 'number' && nextOrders.length >= nextTotalCount) {
            return nextOrders;
        }

        return collectPage(page + 1, nextOrders, nextTotalCount);
    };

    return collectPage(0, [], undefined);
};
